import { Box, Flex, Icon, Collapse, useDisclosure } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { ChevronDown, ChevronRight } from '@kula-ai/icons-core';

export const RequisitionDetailsSection = ({
  title = 'Details',
  children,
  defaultIsOpen = true,
  isCollapsible = true,
}) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen });

  return (
    <Box
      borderRadius="xs"
      border="1px solid"
      borderColor="border-color"
      overflow="hidden"
      width="370px"
      minW="0"
    >
      <Flex
        onClick={isCollapsible ? onToggle : undefined}
        flex="1"
        p="12px 16px"
        cursor={isCollapsible ? 'pointer' : 'default'}
        bg="secondary-25"
        gap="6px"
        alignItems="center"
        borderBottom={(isCollapsible ? isOpen : true) && '1px solid'}
        borderColor="border-color"
      >
        {isCollapsible && (
          <Icon
            width="16px"
            height="16px"
            cursor="pointer"
            as={isOpen ? ChevronDown : ChevronRight}
            onClick={onToggle}
          />
        )}
        <KText variant="heading_4" color="primary-900" fontWeight="semiBold">
          {title}
        </KText>
      </Flex>
      {isCollapsible ? (
        <Collapse
          in={isOpen}
          unmountOnExit={false}
          style={{ width: '100%', minWidth: 0 }}
        >
          {children}
        </Collapse>
      ) : (
        children
      )}
    </Box>
  );
};
